import { render, staticRenderFns } from "./Rappel.vue?vue&type=template&id=ff99ef78&scoped=true&lang=true&"
import script from "./Rappel.vue?vue&type=script&lang=js&"
export * from "./Rappel.vue?vue&type=script&lang=js&"
import style0 from "./Rappel.vue?vue&type=style&index=0&id=ff99ef78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff99ef78",
  null
  
)

export default component.exports